import styles from 'css/Splash.module.css'
import { useEffect, useRef } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { Portal } from 'components'
import anime from 'animejs'
// import anime from 'animejs/lib/anime.es.js'

const Splash = ({ show, setShow, callback }) => {

	const splash = useRef()

	//#region variants
	const variants = {
		exit: {
			opacity: 0,
			transition: {
				duration: 2,
				type: "tween"
			}
		}
	}

	const sloganAni = {
		initial: {
			y: 100,
			opacity: 0
		},
		animate: {
			y: 0,
			opacity: 1,
			transition: {
				delay: 0.7
			}
		},
		exit: {
			
		}
	}
	
	const nameAni = {
		initial: {
			y: 100,
			opacity: 0
		},
		animate: {
			y: 0,
			opacity: 1,
			transition: {
				delay: 1
			}
		},
		exit: {
			
		}
	}
	
	const logoAni = {
		initial: {
			x: 300
		},
		animate: {
			x: 0,
			transition: {
				delay: 1.3
			}
		},
		exit: {

		}
	}
	//#endregion

	useEffect(() => {
		setTimeout(() => {
			if (!show || !splash || !splash.current) return
			const clone = splash.current.cloneNode(true)
			splash.current.after(clone)
			const wrap = document.createElement("div")
			const wrap2 = document.createElement("div")
			wrap.classList.add(styles.wrap)
			wrap2.classList.add(styles.wrap)
			splash.current.parentNode.appendChild(wrap)
			clone.parentNode.appendChild(wrap2)
			wrap.appendChild(splash.current)
			wrap2.appendChild(clone)

			anime({
				targets: wrap,
				translateY: "-100%",
				duration: 300,
				easing: "easeOutQuad",
				complete () {
					splash.current.style.display = "none"
					wrap.parentNode.appendChild(splash.current)
					wrap.remove()
					// setShow(false)
					setShow(false)
					if (callback) callback()
				}
			})
			anime({
				targets: wrap2,
				translateY: "100%",
				duration: 300,
				easing: "easeOutQuad",
				complete () {
					wrap2.remove()
				}
			})
		}, 3500)

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<Portal to="modal">
			<AnimatePresence>
			{show &&
				<motion.div ref={splash} variants={variants} initial="initial" animate="animate" className={styles.splash}>
					<div className={styles.center}>
						<motion.div variants={sloganAni} className={styles.slogan}>자산을 담다</motion.div>
						<motion.div variants={nameAni} className={styles.appName}>MoneyBowl</motion.div>
					</div>
					<motion.div variants={logoAni} className={styles.logo}></motion.div>
				</motion.div>
			}
			</AnimatePresence>
		</Portal>
	)
}

export default Splash
